import { ResetToTriggeringSpinCommand } from "slotworks/commands/betbar/reset-to-triggering-spin";
import { SetWinningsCommand } from "slotworks/commands/betbar/set-winnings-command";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import Gamestate from "slotworks/model/game-state";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import SmartButton from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import ShowPromoFSafterFreespins from "slotworks/commands/promo-free-spins/show-pfs-after-freespins";

export default class ExitFreespins extends State {

    protected summaryScenes: string[] = ["freespinssummary", "freespins"];
    protected promptContents: Map<string, string>;

    private prompt: PromptContent;

    public onEnter() {
        this.prompt = null;
        this.promptContents = new Map<string, string>();
        sequence([
            () => this.beforePrompt(),
            () => this.setupPrompt(),
            () => this.showPrompt(),
            () => this.afterPrompt()
        ]).then(() => this.complete());
    }

    public complete() {
        GameState.getCurrentGame().inFreespinsGame = false;
        Regulation.updateNetPosition(GameState.getNetPosition());
        this.setWinnings();
        super.complete();
    }

    protected beforePrompt() {
        return Contract.empty();
    }

    protected setupPrompt() {
        return Contract.wrap(() => {
            SmartButton.setFlag(SmartButtonFlag.PROMPT, true);

            const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();
            let message;
            let summaryScene;

            if (freeSpinsWin > 0) {
                message = Translations.get("fs.wsu", { VALUE: freeSpinsWin });
                summaryScene = "freespinssummary";
            } else {
                message = Translations.get("fs.nws");
                summaryScene = "freespinsnowin";
            }

            const freespinsRecord = Gamestate.getCurrentGame().getCurrentRecord() as FreespinRecord;
            const freespinsPlayed = freespinsRecord.totalFreespins.toString();

            this.prompt = new PromptContent([summaryScene, ...this.summaryScenes], 4000);
            this.prompt.addContinueButton("continue");

            this.promptContents.set("winMessage", message);
            this.promptContents.set("played", freespinsPlayed);
            this.prompt.addText(this.promptContents);

            this.prompt.countupText("value", freeSpinsWin, 2000);
        });
    }

    protected showPrompt(): Contract<void> {
        return Components.prompt.showPrompt(this.prompt);
    }

    protected afterPrompt() {
        return parallel([
            () => Contract.wrap(() => {
                SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
                ShowPromoFSafterFreespins();
            }),
            () => this.hideFreespinsComponents(),
            () => this.resetToTriggeringSpin()
        ]);
    }

    protected hideFreespinsComponents(): Contract<void> {
        return parallel([
            () => Layers.Background.defaultScene(),
            () => Layers.MatrixBackground.defaultScene(),
            () => Layers.Header.defaultScene(),
            () => Contract.wrap(() => Components.banner.setMode("default")),
            () => Contract.wrap(() => Components.footer.showDefaultText())
        ]);
    }

    protected resetToTriggeringSpin() {
        return Contract.wrap(() => ResetToTriggeringSpinCommand());
    }

    protected setWinnings(): void {
        const totalWin = GameState.getCurrentGame().totalCreditsWon;
        Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/exit-freespins.ts